import {
  HYDRATE,
  type HydrateAction,
} from '@/domains/core/applicationState/store/hydrateAction';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import { ProductPageDependenciesB2BQuery } from '@/domains/productDiscovery/ProductPage/graphql/productPageDependenciesB2B/generated/productPageDependeciesB2B.generated';
import { ProcessedRecommendationItem } from '@/domains/productDiscovery/Recommendation/interfaces/msRecommendation';
import {
  GRAPHQL_SUCCESS,
  GraphqlSuccess,
} from '@/productDiscovery/ProductPage/detail.actions';

import {
  selectProductRecommendationConfigs,
  selectProductRecommendations,
} from '../../selectors/productRecommendation';
import {
  initialState,
  type ProductRecommendationState,
} from './interfaces/ProductRecommendation.model';
import {
  CONFIG_PROCESSING_FAILED,
  CONFIG_PROCESSING_SUCCESS,
  FETCH_PRODUCTS_RECOMMENDATION,
  FETCH_PRODUCTS_RECOMMENDATION_FAILED,
  FETCH_PRODUCTS_RECOMMENDATION_SUCCESS,
  FETCH_RECOMMENDATION_CONFIG,
  FETCH_RECOMMENDATION_CONFIG_FAILED,
  FETCH_RECOMMENDATION_CONFIG_SUCCESS,
  type Action,
} from './ProductRecommendation.actions';

export default function reducer(
  state: ProductRecommendationState = initialState,
  action:
    | HydrateAction<SpartacuxProductDiscoveryDomainState>
    | GraphqlSuccess
    | Action,
): ProductRecommendationState {
  switch (action.type) {
    case HYDRATE:
      return {
        ...state,
        recommendationsConfig: selectProductRecommendationConfigs(action.state),
        recommendations: selectProductRecommendations(action.state),
      };

    case FETCH_RECOMMENDATION_CONFIG:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_RECOMMENDATION_CONFIG_SUCCESS:
      return {
        ...state,
        recommendationsConfig: action.config,
        fetching: false,
      };

    case FETCH_RECOMMENDATION_CONFIG_FAILED:
      return {
        ...state,
        fetching: false,
        error: action.error.message,
        recommendationsConfig: [],
      };

    case FETCH_PRODUCTS_RECOMMENDATION:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_PRODUCTS_RECOMMENDATION_SUCCESS:
      return {
        ...state,
        fetching: false,
        recommendations: state.recommendations
          ? [...state.recommendations, ...action.recommendations]
          : action.recommendations,
      };

    case FETCH_PRODUCTS_RECOMMENDATION_FAILED:
      return {
        ...state,
        fetching: false,
        error: action.error.message,
        recommendations: [],
      };

    case CONFIG_PROCESSING_SUCCESS:
      return {
        ...state,
        recommendationsConfig: action.config,
        fetching: false,
      };

    case CONFIG_PROCESSING_FAILED:
      return {
        ...state,
        fetching: false,
        error: action.error.message,
        recommendationsConfig: [],
      };

    case GRAPHQL_SUCCESS: {
      const { payload } = action;
      const recommendations: ProductPageDependenciesB2BQuery['recommendations'] =
        payload?.recommendations;

      if (!recommendations?.length)
        return {
          fetching: false,
          recommendationsConfig: [],
        };

      const parsedRecommendations = recommendations.map(
        // TODO: Clean the old interface 'ProcessedRecommendationItem' when the 'productPageGraphQL' AB is finished
        (reco): ProcessedRecommendationItem => ({
          engineName: reco.engineName,
          displayAddToCartButton: false,
          displayType: 'product-list',
          name: reco.engineName,
          modelIds: reco.channelOffers.modelIds?.map(Number),
          originalName: reco.canonicalName,
        }),
      );

      return {
        ...state,
        fetching: false,
        recommendationsConfig: parsedRecommendations,
      };
    }

    default:
      return state;
  }
}
